import jQuery from 'jquery';

declare global {
	interface Window {
		$: JQueryStatic;
		jQuery: JQueryStatic;
	}
}

window.$ = jQuery;
window.jQuery = jQuery;

(globalThis as typeof globalThis & { $: JQueryStatic; jQuery: JQueryStatic }).$ = jQuery;
(globalThis as typeof globalThis & { $: JQueryStatic; jQuery: JQueryStatic }).jQuery = jQuery;

export {};